import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  totalAum: "Total AUM",
  aumSubtitle: "Cash and positions, today",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    totalAum: "Encours sous gestion",
    aumSubtitle: "Liquidités et positions, aujourd'hui",
  },
  es_ES: {
    totalAum: "Patrimonio gestionado",
    aumSubtitle: "Efectivo y posiciones, hoy",
  },
  pt_BR: {
    totalAum: "Patrimônio sob gestão",
    aumSubtitle: "Caixa e posições, hoje",
  },
  de_DE: {
    totalAum: "Verwaltetes Vermögen",
    aumSubtitle: "Liquidität und Positionen, heute",
  },
  it_IT: {
    totalAum: "Patrimonio gestito",
    aumSubtitle: "Liquidità e posizioni, oggi",
  },
  ar: {
    totalAum: "إجمالي الأصول المُدارة",
    aumSubtitle: "النقد والمراكز، اليوم",
  },
  ja_JP: {
    totalAum: "運用資産残高（AUM）合計",
    aumSubtitle: "現金およびポジション（本日時点）",
  },
  hi_IN: {
    totalAum: "कुल प्रबंधनाधीन परिसंपत्तियाँ (AUM)",
    aumSubtitle: "नकद और पोज़िशन, आज तक",
  },
  zh_CN: {
    totalAum: "管理资产规模 (AUM) 总计",
    aumSubtitle: "现金及持仓，截至今日",
  },
  zh_TW: {
    totalAum: "管理資產規模 (AUM) 總計",
    aumSubtitle: "現金及持有部位，截至今日",
  },
  nl_NL: {
    totalAum: "Totaal beheerd vermogen",
    aumSubtitle: "Liquide middelen en posities, vandaag",
  },
  nb_NO: {
    totalAum: "Total forvaltningskapital",
    aumSubtitle: "Kontanter og posisjoner, i dag",
  },
  sv_SE: {
    totalAum: "Totalt förvaltat kapital",
    aumSubtitle: "Likvida medel och innehav, i dag",
  },
  fi_FI: {
    totalAum: "Hallinnoitavat varat yhteensä",
    aumSubtitle: "Käteinen ja positiot, tänään",
  },
  da_DK: {
    totalAum: "Samlet formue under forvaltning",
    aumSubtitle: "Kontanter og positioner, i dag",
  },
  is_IS: {
    totalAum: "Eignir í stýringu alls",
    aumSubtitle: "Reiðufé og stöður, í dag",
  },
};
